// @flow

import memoize from "fast-memoize";

export default function<T>(func: T): T {
  return memoize(func);
}
